angular.module('jv.candidate.details.notes.controller',[])
    .controller('jvCandDetailsNotesController', ['$scope','candidates','$routeParams','$rootScope','jvNotesFactory',
        function($scope, candidates, $routeParams, $rootScope, jvNotesFactory){
            var refreshNotes = function(event,list){
                $scope.notes = list;
            };
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.$parent.jump = 'all';
            $scope.applicationId = $routeParams.applicationId;
            $scope.$root.activeNoteIndex;
            $scope.flags.loading = false;
            $scope.flags.expanded = false;
            $scope.$parent.processing = false;
            // clearing out the notes(maintained in the parent) from earlier.
            $scope.$parent.notes = [];
            $scope.$root.modal = {
                show : false,
                buttons : [ {
                    label : i18n.DELETE,
                    click : function() {
                        $scope.deleteNote();
                    }
                }, {
                    label : i18n.CANCEL,
                    click : function() {
                        $scope.$root.modal.show = false;
                        $scope.$root.activeNoteIndex = -1;
                    },
                    'class' : 'cancel'
                } ],
                cancel : function() {
                    this.show = false;
                },
                title : i18n.DELETE_NOTE,
                body : i18n.DELETE_NOTE_CNFRM
            };

            /*Tinymce configs*/
            $scope.disableTinymceOnStart = false;
            $scope.jvTinymceEditable = true;
            $scope.jvRenderTinymceOnLoad = true;
            $scope.jvTinymceOptions = ' ';
            $scope.jvTinymceMenubar = false ;

            $scope.openFlyout = function(){
                $scope.flags.noteMandetoryFlag = false;
                $scope.flags.quickForms = 'note';
                $scope.showQForm('note');
            };

            $scope.edit = function(index) {
                $scope.notes[index].form = true;
                //$scope.$parent.forms[index] = angular.copy($scope.notes[index],$scope.$parent.forms[index]);
                $scope.forms[index] = angular.extend($scope.forms[index],$scope.notes[index]);
                angular.forEach($scope.forms[index].attachments, function(attachment){
                    attachment.resourceInfo = {
                        eid: attachment.EId,
                        fileName: attachment.fileName
                    };
                    attachment['selected'] = true;
                });
                $scope.forms[index].htmlMessage = $scope.forms[index].content;
                //NV: Fix for bug HIRE-5453 and HIRE-8265.
                //While editing a note the to field was getting populated automatically. Setting this to empty array to make sure when you edit a note the to field is empty which is always the case.
                $scope.forms[index].to = [];
                if($scope.$parent.noteTemplates && !$scope.$parent.noteTemplates.length){
                    candidates.getNoteTmpl($routeParams.applicationId,{},function(data) {
                        if (data.msgInfo === $scope.status.OK) {
                            $scope.$parent.noteTemplates_Copy = angular.copy(data.templates);
                            $scope.$parent.noteTemplates = $scope.select2Options.setTemplates(data.templates);
                        }
                    });
                }else{
                    $scope.noteTemplates = $scope.select2Options.setTemplates($scope.$parent.noteTemplates_Copy);
                }
            };

            $scope.reply = function(index) {
                $scope.notes[index].form = true;
                $scope.forms[index] = {
                    to : [],
                    template:'',
                    subject: $scope.notes[index].subject || ''
                };
                $scope.forms[index].to.push($scope.notes[index].from.EId);
                if($scope.$parent.noteTemplates && !$scope.$parent.noteTemplates.length){
                    candidates.getNoteTmpl($routeParams.applicationId,{},function(data) {
                        if (data.msgInfo === $scope.status.OK) {
                            $scope.$parent.noteTemplates = $scope.select2Options.setTemplates(data.templates);
                        }
                    });
                }
            };
            //Add or remove attachment while editing note
            $scope.editAttachment = function(attachment){
                if(attachment.selected){
                    attachment.resourceInfo = {
                        eid: attachment.EId,
                        fileName: attachment.fileName
                    };
                } else {
                    delete attachment.resourceInfo;
                }
            };

            $scope.$watch('notes', function(newVal){
                if (angular.isArray(newVal)) {
                    angular.forEach(newVal, function(note, key){
                        if (!$scope.forms[key]) {
                            $scope.forms[key] = {};
                        }
                    });
                }
            });

            $scope.$watch('jump', function(newVal){
                if((newVal === 'saved' || newVal === 'sent') && ($scope.notes.length !== ($scope.savedNotes + $scope.sentNotes)))
                {
                    $scope.loadMore();
                }
            });

            $scope.loadMore = function(){
                $scope.$parent.processing=true;
                $scope.getNotes($scope.notes?$scope.notes.length:0, $scope.page.count, function(notes){
                    if(notes){
                        $scope.$parent.notes = $scope.$parent.notes.concat(notes);
                        refreshNotes(null,$scope.notes.concat(notes));
                    }
                    $scope.$parent.processing=false;
                });
            };

            $scope.hasMore = function(){
                var count = $scope.jump === 'saved' ? $scope.savedNotes : ( $scope.jump === 'sent' ? $scope.sentNotes : ($scope.savedNotes+$scope.sentNotes) );
                return $scope.notes.length < count;
            };

            $scope.confirmDelete = function(index){
                $scope.$root.modal.show = true;
                $scope.$root.activeNoteIndex = index;
            };

            //event to track and update notes count
            $rootScope.$on('updateNoteCount',function(){
                $scope.getNotesCount(true);
            });
            
            var deleteNote = function(postData){
                $scope.flags.loading = true;
                jvNotesFactory.deleteNote(postData,function(response){
                    if(response && response.msgInfo === 200){
                        $scope.$root.activeNoteIndex = -1;
                        $scope.flags.deleted = true;
                        setTimeout(function(){
                            $scope.flags.deleted = false;
                        },500);
                        $scope.getNotesCount(true);
                        $scope.flags.loading = false;
                    }
                });
            };

            $scope.deleteNote = function(){
                var data;
                if($scope.$root.activeNoteIndex < 0){
                    return;
                }
                $scope.$root.modal.show = false;
                $scope.flags.loading = true;
                $scope.notes[$scope.$root.activeNoteIndex].form = false;

                data = {
                    id: $scope.notes[$scope.$root.activeNoteIndex].EId,
                    applicationId: $routeParams.applicationId
                };
                // Delete it from the displayed notes - length of notes array is used later and deleting this will reflect the actual length
                $scope.notes.splice($scope.$root.activeNoteIndex, 1);
                deleteNote(data);
            };

            $scope.isEdittable = function(note) {
                return jvNotesFactory.isEdittable(note);
            };

            $scope.isReplyable = function(note){
                if(!note.to){
                    return false;
                }
                for(var i = 0; i< note.to.length; i++){
                    return jvNotesFactory.isReplyable(note,note.to[i]);
                }
            };

            // Tab was clicked
            if($scope.$parent.tabClicked === 'notes'){
                $scope.getNotes(0, $scope.page.count);
                $scope.getNotesCount();
             } else if($scope.activeTab('notes')){   // Page was refreshed, not a tab click
                $scope.getNotes(0, $scope.page.count);
            }
            $scope.$on('load_application_notes', refreshNotes);
    }]
);